import { Box, Typography, useTheme } from '@mui/material';
import FantasyLaLigaIcon from '@/components/shared/icons/fantasy-la-liga-icon';
import HomeIcon from '@/components/shared/icons/home-icon';
import AirPlaneIcon from '@/components/shared/icons/airplane-out-icon';
import FixtureScore from '@/components/shared/fixture-score';
import AlineacionesActivityIcon from '@/components/home/icons/alineaciones-activity-icon';
import CustomSectionWrapper from '@/DesignSystem/wrappers/CustomSectionWrapper';

const InfoItem = ({ icon: Icon, value, size = 16, iconProps = {}, theme }) => (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: '2px' }}>
        <Icon width={size} {...iconProps} />
        <Typography fontSize={14} sx={{ color: theme.palette.text.primary }}>
            {value}
        </Typography>
    </Box>
);

const EstadisticasLaLigaFantasy = ({ player, slug }) => {
    const theme = useTheme();
    const homePoints = player?.fi?.ph;
    const awayPoints = player?.fi?.pa;
    const playedHome = player?.fi?.plh;
    const playedAway = player?.fi?.pla;
    const mediaTotal = player?.fi?.m?.toFixed(2);
    const totalPoints = player?.fi?.p;
    const racha = player?.fi?.fi;

    const mediaCasa = playedHome > 0 ? homePoints / playedHome : 0;
    const mediaFuera = playedAway > 0 ? awayPoints / playedAway : 0;

    return (
        <CustomSectionWrapper color="accent" title="Estadísticas La Liga Fantasy">
            <Box
                display="flex"
                justifyContent="space-between"
                sx={{ flexDirection: { xs: 'column' }, gap: '4px' }}
            >
                <Box sx={{ display: 'flex', alignItems: 'center', gap: '6px' }} fontSize={14}>
                    <Typography variant="h3" fontSize={14}>
                        Puntos La Liga Fantasy:
                    </Typography>
                    <InfoItem
                        theme={theme}
                        icon={FantasyLaLigaIcon}
                        value={totalPoints}
                        iconProps={{ iconWidth: 16, iconHeight: 16 }}
                    />
                    <InfoItem theme={theme} icon={HomeIcon} value={homePoints} />
                    <InfoItem theme={theme} icon={AirPlaneIcon} value={awayPoints} size={15} />
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: '6px', fontSize: '14px' }}>
                    <Typography variant="h3" fontSize={14}>
                        Media:
                    </Typography>
                    <InfoItem theme={theme} icon={AlineacionesActivityIcon} value={mediaTotal} size={15} />
                    <InfoItem theme={theme} icon={HomeIcon} value={mediaCasa?.toFixed(2)} size={15} />
                    <InfoItem theme={theme} icon={AirPlaneIcon} value={mediaFuera?.toFixed(2)} size={15} />
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                    <Typography variant="h3" fontSize={14}>
                        Racha actual:
                    </Typography>
                    {racha?.map((value, index) => (
                        <FixtureScore
                            key={index}
                            score={Number(value)}
                            isAvailable={true}
                            width="16px"
                            height="16px"
                        />
                    ))}
                </Box>
            </Box>
        </CustomSectionWrapper>
    );
};

export default EstadisticasLaLigaFantasy;
